/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#getIsAdminUser__anchor
 */
export default () => window.documentViewer.getAnnotationManager().isUserAdmin();
